import React, { useEffect, useState } from 'react';
import '../App.css';

import '../styles/joinUs.css'

import 'react-responsive-modal/styles.css';
import Button from '../components/Button';
import Input from '../components/Input';
import { toast } from 'react-toastify';

interface props {
    refProp: any,
}

function JoinUs({refProp}: props) {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const submitDetails = async () => {
        try {
            const response = await fetch('/api/mailchimp', {method: 'POST', body: JSON.stringify({ email: email, firstName: firstName, lastName: lastName })}); // Adjust the path if needed
            if (!response.ok) {
                setSubmitted(false);
                setError('Something went wrong, please refresh and try again.');
                return;
            }
            setSubmitted(true);
            setError('')
        } catch (error) {
            setError('Something went wrong, please refresh and try again.');
            setSubmitted(false);
        }
    };

    useEffect(() => {
        setError('')
        setSubmitted(false);
    }, [email, firstName, lastName])

    return (
        <div className='join-section' ref={refProp}>
            <h1 className='section-title'>Join Us</h1>
            <p className='text-medium small'>Sign up below with just your name and email, and we’ll be in touch.</p>
            <div className='form-container'>
                <div className='form'>
                    <div className='form-left'>
                        <h3 className='no-margin'>Join Labour in the City</h3>
                        <div className='form-left-lower'>
                            <img src={require('../assets/wired-flat-981-consultation.gif')} className='join-icon'/>
                            <div className='form-left-lower-text'>
                                <p>Are you a Labour supporter working in Financial Services or any of the associated industries?</p>
                                <p>Join today.</p>
                            </div>
                        </div>
                    </div>
                    <div className='form-right'>
                        <p className='form-entry-label-first'>First Name</p>
                        <Input placeholder='John' callback={(fName: string) => setFirstName(fName)}></Input>
                        <p className='form-entry-label'>Last Name</p>
                        <Input placeholder='Doe' callback={(lName: string) => setLastName(lName)}></Input>
                        <p className='form-entry-label'>Email address</p>
                        <Input placeholder='someone@example.com' callback={(email: string) => setEmail(email)}></Input>
                        {error && <p style={{color: 'red'}}>{error}</p>}
                        <Button type="tertiary" text={!submitted ? "Submit" : "Submitted"} callback={() => submitDetails()}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinUs;
